module.exports = __webpack_public_path__ + "img/SLS-Rice-Pattern.5e464151.svg";